"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requireFields = requireFields;
function requireFields(obj, keys) {
    const result = {};
    for (const key of keys) {
        const value = obj[key];
        if (value === null) {
            throw new Error(`Missing required field: ${String(key)}`);
        }
        result[key] = value;
    }
    return result;
}
//# sourceMappingURL=require-fields.js.map